<template>
  <FilterSingleChip
    icon="bookmark"
    :is-text="isText"
    :label="$t('search-filters.action-filters.followed')"
    :items="items"
    :value="value && value.length ? value[0] : null"
    @change="onChange"
  />
</template>

<script>
import FilterSingleChip from '@/components/filters/FilterSingleChip';
import { FOLLOWED_FILTERS_VALUES } from '@/models/search-filters';

/**
 * Saved/followed dimension chip (followed / unfollowed). A single choice stored as an array
 * (followFilters) — adapts array↔value around a single-select FilterSingleChip. Presentational:
 * `:value` (array) in, `change` (0/1 array) out.
 */
export default {
  name: 'FollowedChip',
  components: { FilterSingleChip },
  props: {
    value: { type: Array, default: () => [] },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return FOLLOWED_FILTERS_VALUES.map((value) => ({
        value,
        text: this.$t(`search-filters.action-filters.values.${value}`),
      }));
    },
  },
  methods: {
    onChange(next) {
      this.$emit('change', next == null ? [] : [next]);
    },
  },
};
</script>
